export const DEFAULT_ACTION = '@@cityoo-tenant/DEFAULT_ACTION';
export const RESET_ALL = '@@cityoo-tenant/RESET_ALL';
